<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
    <van-cell-group>
      <van-cell title="实名认证" label="上传身份证信息，完成后自动关联运动员、裁判员、教练员数据" v-if="false">
        <template #right-icon>
          <div class="tiny-btn-1">去认证</div>
        </template>
      </van-cell>
      <van-cell title="家长认证" label="上传身份证明信息，完成后自动关联子女运动员信息" v-if="false">
        <template #right-icon>
          <div class="tiny-btn-1">管理</div>
        </template>
      </van-cell>
      <van-cell title="单位认证" label="关联CCA单位信息，完成后可获得单位相关业务权限">
        <template #right-icon>
          <div class="tiny-btn-1" v-if="row.danwei.registstatus==0" v-rblink="{name:'CertDanwei'}">去认证</div>
          <div class="tiny-btn-0" v-else-if="row.danwei.registstatus==3" v-rblink="{name:'CertDanweiResult'}">认证失败</div>
          <div class="tiny-btn-0" v-else-if="row.danwei.registstatus==1" v-rblink="{name:'CertDanweiResult'}">审核中</div>
          <div class="tiny-btn-0" v-else-if="row.danwei.registstatus==2" @click="unbind">解除认证</div>
          <div class="tiny-btn-0" v-if="row.danwei_list.length>1"  @click="sheetActiveShow=true" style=" position: absolute;
    right: 16px;
    top: 50px;">切换单位</div>
        </template>
      </van-cell>
      <van-cell :value="row.danwei.name" v-if="row.danwei.registstatus==2">
        <template #icon>
          <van-tag plain type="success">已认证</van-tag>
        </template>
      </van-cell>

      <div class="bottom-button">
        <van-button round type="default" v-rblink="{name:'YundongyuanList'}">运动员管理</van-button>
        <van-button round type="default" v-rblink="{name:'CaipanList'}">随队裁判员</van-button>
        <van-button round type="default" v-rblink="{name:'JiaolianList'}">随队教练员</van-button>
      </div>
      <div style="height: 10px"></div>
      <!--

      <van-cell title="考级中心/考级点"  label="注册或者关联考级中心考级点信息，获取七彩星级申报业务权限">
          <template #right-icon>
              <div class="tiny-btn-1" v-if="row.exame_center.kaojiregist_status==0" v-rblink="{name:'QcxjStationCert'}">去认证</div>
              <div class="tiny-btn-0" v-else-if="row.exame_center.kaojiregist_status==3" v-rblink="{name:'QcxjStationResult'}">认证失败</div>
              <div class="tiny-btn-0" v-else-if="row.exame_center.kaojiregist_status==1" v-rblink="{name:'QcxjStationResult'}">审核中</div>
          </template>
      </van-cell>
      <van-cell :value="row.exame_center.danwei"  v-if="row.exame_center.kaojiregist_status==2"  >
          <template #icon>
              <van-tag plain type="success">已认证</van-tag>
          </template>
      </van-cell>

      <div class="bottom-button">
          <van-button round type="default" v-rblink="{name:'ExameApplyList'}">七彩星级考级申报</van-button>
          <van-button round type="default" v-if="row.exame_center.kaojitype=='考级中心'" v-rblink="{name:'ExameApplySList'}">我授权的申报</van-button>
      </div>
      <van-cell title="我参加的七彩星级运动员申报"  is-link  v-rblink="{name:'ExameApplyJoinMemberList'}" >  </van-cell>
      <div style="height: 10px"></div>

      <van-cell title="CBA培训班"  label="七彩星级CBA及监督线上培训班申报">
      </van-cell>
      <div class="bottom-button">
          <van-button round type="default" v-rblink="{name:'CbaApplyFormBasic',query:{station_id:6}}">C级班</van-button>
          <van-button round type="default" v-rblink="{name:'CbaApplyFormBasic',query:{station_id:5}}">B级班</van-button>
          <van-button round type="default" v-rblink="{name:'CbaApplyFormBasic',query:{station_id:4}}">A级班</van-button>
      </div>
      <van-cell title="我的申报记录"  is-link  v-rblink="{name:'CbaApplyList'}" >  </van-cell>

      <van-cell title="俱乐部认证"  label="认证俱乐部资质，获取星级俱乐部权限">
          <template #right-icon>
              <div class="tiny-btn-1" v-if="row.club.registstatus==0" v-rblink="{name:'ClubApply'}">去认证</div>
              <div class="tiny-btn-0" v-else-if="row.club.registstatus==3" v-rblink="{name:'CertClubResult'}">认证失败</div>
              <div class="tiny-btn-0" v-else-if="row.club.registstatus==1" v-rblink="{name:'CertClubResult'}">审核中</div>
              <div class="tiny-btn-0" v-else-if="row.club.registstatus==2" @click="unbind">解除认证</div>
          </template>
      </van-cell>
      <van-cell :value="row.club.danwei"  v-if="row.club.registstatus==2"  >
          <template #icon>
              <van-tag plain type="success">已认证</van-tag>
          </template>
      </van-cell>
      <van-cell title="验收报告上传"  is-link  v-rblink="{name:'ClubApplyYanshou'}" >  </van-cell>
      <van-cell title="俱乐部建设订单"  is-link  v-rblink="{name:'ClubJiansheList'}" >  </van-cell>
      <div style="height: 10px"></div>
-->
    </van-cell-group>

    <van-cell-group>
      <van-cell title="实名认证" label="关联实名信息，完成后可获得个人相关业务权限">
        <template #right-icon>
          <div class="tiny-btn-1" v-if="row.cert.status==0" @click="showNumTypePicker = true">去认证</div>
          <div class="tiny-btn-0" v-else-if="row.cert.status==1" @click="unbindPerson" >解除认证</div>
        </template>
      </van-cell>
      <van-cell :value="row.cert.user_name +' ' + row.cert.user_code" v-if="row.cert.status==1">
        <template #icon>
          <van-tag plain type="success">已实名</van-tag>
        </template>
      </van-cell>

      <div class="bottom-button" v-if="row.cert.status==1">
        <van-button round type="default" v-rblink="{name:'UserSearchCaipan'}">裁判员资质查询</van-button>
        <van-button round type="default" v-rblink="{name:'UserSearchJiaolian'}">教练员资质查询</van-button>
      </div>
      <div style="height: 10px"></div>
    </van-cell-group>
    <van-cell-group>
      <van-cell title="证件照管理" label="裁判员、教练员等证书照片显示">
        <template #right-icon>
          <div class="tiny-btn-1" v-rblink="{name:'CertPersonPhoto'}">去管理</div>
          <div v-if="row.photo.status==2" class="tiny-btn-0 green" style="border: 1px solid #42BD56;margin-left: .1rem" v-rblink="{name:'CertPersonPhoto'}">审核成功</div>
          <div v-if="row.photo.status==3" class="tiny-btn-0" style="margin-left: .1rem" v-rblink="{name:'CertPersonPhoto'}">审核失败</div>
        </template>
      </van-cell>
    </van-cell-group>

    <van-cell-group v-if="row.weiyuanhui_list.length > 0">
      <van-cell title="省市管理" label="管理赛事、会议、七彩星级、俱乐部、大课间等信息">
        <template #right-icon>
          <div class="tiny-btn-1" v-rblink="{name:'WeiyuanhuiList'}">去选择</div>
        </template>
      </van-cell>
    </van-cell-group>


    <van-cell-group >
      <van-cell title="区域合伙人管理" label="个人在所在区域内所有销售业务管理">
        <template #right-icon>
          <div class="tiny-btn-1"  >去选择</div>
        </template>
      </van-cell>
    </van-cell-group>

    <van-cell-group >
      <van-cell title="个人合伙人管理" label="个人所有销售业务管理">
        <template #right-icon>
          <div class="tiny-btn-1"  >去管理</div>
        </template>
      </van-cell>
    </van-cell-group> 

    <van-cell-group >
      <van-cell title="省服务专员" label="所联络的省份的所有销售订单管理">
        <template #right-icon>
          <div class="tiny-btn-1"  >管理订单</div>
        </template>
      </van-cell>
    </van-cell-group>

    <van-cell-group >
      <van-cell title="公司内部管理" label="CCA公司内部业务管理：销售订单管理，推荐订单管理">
        <template #right-icon>
          <div class="tiny-btn-1"  >去管理</div>
        </template>
      </van-cell>
    </van-cell-group>
<!--    <van-cell-group>-->
<!--      <van-cell title="技术等级申报" label="运动员技术等级申报">-->
<!--        <template #right-icon>-->
<!--          <div class="tiny-btn-1" v-rblink="{name:'LevelApplyList'}">去申报</div>-->
<!--        </template>-->
<!--      </van-cell>-->
<!--    </van-cell-group>-->
<!--    <van-cell-group>-->
<!--      <van-cell title="能力测试申报" label="个人能力测试申报">-->
<!--        <template #right-icon>-->
<!--          <div class="tiny-btn-1" v-rblink="{name:'AbilityApplyList'}">去申报</div>-->
<!--        </template>-->
<!--      </van-cell>-->
<!--    </van-cell-group>-->

    <van-popup v-model="showNumTypePicker" position="bottom">
      <van-picker :columns="numTypeColumns"
                  show-toolbar
                  title="实名验证类型选择"
                  @cancel="showNumTypePicker = false"
                  @confirm="onNumTypeConfirm"
      />
    </van-popup>


    <van-action-sheet
      v-model="sheetActiveShow"
      description="将以新的单位为主体参赛报名"
      :actions="row.danwei_list"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSelect"
    />

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'CertIndex',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      sheetActiveShow:false,
      sheetActiveActions: [{ name: '单位1' }],
      loginShow: false,
      saveLoading: false,
      showArea: false,
      showNumTypePicker: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      row: {
        weiyuanhui_list: [],
        danwei_list: [],
        danwei: {},
        exame_center: {},
        club: {},
        cert: {
          status: 0
        },
        photo: {}
      },
      formData: {},
      numTypeColumns: ['身份证', '护照','其他身份证明'],
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "认证首页"
    this.fetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onSheetCancel() {
      // Toast('取消');
    },
    onSelect(action,index){
      console.log(action,index)   
      let that = this;
      that.$api.post('/api/user/danweiChange', {
        danwei_id  : action.id
      }, (res) => { 
          Toast('您的备案单位已切换成【'+ action.name+'】');
          that.fetch();
      }, (res) => { 
      })
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/certindex', {}, (res) => {
        that.row = res.data;
      }, (res) => {
        console.log('errrrrr')
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    unbind() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除单位认证吗?'
      }).then(() => {

        that.$api.post('/api/danwei/unbind', {}, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },

    unbindPerson() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除个人认证吗?'
      }).then(() => {

        that.$api.post('/api/user/unbind', {}, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },

    onNumTypeConfirm(value, index){
      console.log('onNumTypeConfirm', value, index)
      this.showNumTypePicker = false;

      let name = 'CertPersonApply'
      if(value != '身份证') {
        name = 'CertPersonApplyOther'
      }

      rbLink({
        name: name
      })
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// CertIndex.vue?b6e499b8